import { http } from './http';

export default (method, url, options) =>
  http.request({
    method,
    url,
    ...options,
  });